import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Grid, Alert, Form, Row, Col } from 'react-bootstrap';
import { Input, DateInput, TimeInput, Select, Checkbox, MultiSelect, HtmlEditor } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { types, getWeekday, addMinutes } from './modes/common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import utils from '../../common/services/utils';

const min0 = validators.minValue(0);
class SettingsForm extends Component {

	constructor(props) {
		super(props);
		this.handleDateChange = this.handleDateChange.bind(this);
		this.handleStartTimeChange = this.handleStartTimeChange.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.useTermDefault && this.props.useTermDefault) {
			this.props.change('themeDescription', null);
		}
		if (!prevProps.useGradeDefault && this.props.useGradeDefault) {
			this.props.change('name', null);
		}
	}

	handleDateChange(event, value) {
		const day = getWeekday(value);
		this.props.change('weekday', day);
	}

	handleStartTimeChange(event, value) {
		const endTime = addMinutes(value, 45);
		this.props.change('endTime', endTime);
	}
	
	renderDateInput(name, label, isReadonly, onChange) {
		return <DateInput name={name} label={label} isReadonly={isReadonly}
			onChange={onChange} validators={validators.required} required />
	}

	renderFromField() {
		const { t, isReadonly } = this.props;
		return <TimeInput name='startTime' label={t('WeeklyProgram_StartTime')} isReadonly={isReadonly}
			onChange={this.handleStartTimeChange} validators={validators.required} required />
	}

	renderToField() {
		const { t, isReadonly } = this.props;
		return <TimeInput name='endTime' label={t('WeeklyProgram_EndTime')} isReadonly={isReadonly}
			validators={validators.required} required/>
	}

	renderGradeField() {
		const { t, isReadonly, grades } = this.props;
		return (
			<Select name='gradeId' disabled={isReadonly} required label={t('WeeklyProgram_Grade')} data={grades} validate={[validators.required]} />
		);
	}

	renderDateField() {
		const { t, isReadonly } = this.props;
		return this.renderDateInput('date', t('WeeklyProgram_Date'), isReadonly, this.handleDateChange);
	}

	renderMaxChildrenField() {
		const { t, isReadonly } = this.props;
		return <Field name='maxChildren' component={Input} disabled={isReadonly}
			type='text' label={t('WeeklyProgram_MaxChildren')} placeholder={t('WeeklyProgram_UseGradeDefault')} validate={[validators.number, min0]} />;
	}

	renderMaxTrialChildrenField() {
		const { t, isReadonly } = this.props;
		return <Field name='maxTrialChildren' component={Input} disabled={isReadonly}
			type='text' label={t('WeeklyProgram_MaxTrialChildren')} placeholder={t('WeeklyProgram_UseGradeDefault')} validate={[validators.number, min0]} />;
	}

	renderMaxMakeupChildrenField() {
		const { t, isReadonly } = this.props;
		return <Field name='maxMakeUpChildren' component={Input} disabled={isReadonly}
			type='text' label={t('WeeklyProgram_MaxMakeUpChildren')} placeholder={t('WeeklyProgram_UseGradeDefault')} validate={[validators.number, min0]} />;
	}

	renderLessonPriceField() {
		const { t, isReadonly } = this.props;
		return <Field name='singleLessonPrice' component={Input} disabled={isReadonly}
			type='text' label={t('WeeklyProgram_SingleLessonPrice')} placeholder={t('WeeklyProgram_UseGradeDefault')} validate={[validators.number, min0]} />;
	}

	renderRecurrenceTypeField() {
		const { t, recurrenceTypes, isReadonly } = this.props;
		return <Select name='recurrenceType' required disabled={isReadonly}
			label={t('WeeklyProgram_RecurrenceType')} data={recurrenceTypes} validate={[validators.required]} />;
	}

	renderDaysOfWeekField() {
		const { t, recurrenceDaysOfWeek } = this.props;
		const daysOfWeek = recurrenceDaysOfWeek ? Object.keys(recurrenceDaysOfWeek)
				.map(id => {
					const entry = recurrenceDaysOfWeek[id];
					return { value: entry.id, label: entry.displayName };
				}) : [];

		return <Field name='daysOfWeek' required component={MultiSelect} options={daysOfWeek} label={t('WeeklyProgram_DaysOfWeek')} validate={[validators.requiredArray]} />;
	}

	renderPriceField() {
		const { t, isReadonly } = this.props;
		return <Field name='price' component={Input} disabled={isReadonly}
			type='text' label={t('WeeklyProgram_Price')} placeholder={t('WeeklyProgram_UseGradePrice')} validate={[validators.number, min0]} />;
	}

	renderRows() {
		const { type } = this.props;

		switch (type) {
			case types.EDIT:
				return this.rederEditFormFields();
			case types.SINGLE:
				return this.renderSingleLessonFormFields();
			case types.TRIAL:
				return this.renderTrialLessonFormFields();
			default:
				return null;
		}
	}

	rederEditFormFields() {
		const { enableMakeUps, enableTrials } = this.props;
		const grade = this.renderGradeField();
		const from = this.renderFromField();
		const to = this.renderToField();
		const maxChildren = this.renderMaxChildrenField();
		const maxTrialChildren = this.renderMaxTrialChildrenField();
		const maxMakeUpChildren = this.renderMaxMakeupChildrenField();
		const priceNumber = 1 + (enableMakeUps ? 1 : 0) + (enableTrials ? 1 : 0);

		return [
			<Row>
				<Col sm={6}>{from}</Col>
				<Col sm={6}>{to}</Col>
			</Row>,
			grade,
			<Row>
				<Col sm={12/priceNumber}>{maxChildren}</Col>
				{enableTrials && <Col sm={12/priceNumber}>{maxTrialChildren}</Col>}
				{enableMakeUps && < Col sm={12/priceNumber}>{maxMakeUpChildren}</Col>}
			</Row>
		];
	}

	renderTrialLessonFormFields() {
		const grade = this.renderGradeField();
		const from = this.renderFromField();
		const to = this.renderToField();
		const date = this.renderDateField();

		return [
			<Row>
				<Col sm={6}>{date}</Col>
				<Col sm={6}>{grade}</Col>
			</Row>,
			<Row>
				<Col sm={6}>{from}</Col>
				<Col sm={6}>{to}</Col>
			</Row>
		];
	}

	renderSingleLessonFormFields() {
		const { t, recurrenceType, isReadonly, initialValues, enableMakeUps, enableTrials } = this.props;
		const isNew = !initialValues || !initialValues.id;

		const grade = this.renderGradeField();

		const from = this.renderFromField();
		const to = this.renderToField();

		const recurrenceTypeField = this.renderRecurrenceTypeField();

		const maxChildren = this.renderMaxChildrenField();
		const maxTrialChildren = this.renderMaxTrialChildrenField();
		const maxMakeUpChildren = this.renderMaxMakeupChildrenField();
		const priceNumber = 1 + (enableMakeUps ? 1 : 0) + (enableTrials ? 1 : 0);

		let fields = [
			<Row>
				{isNew && <div>
				<Col sm={6}>{recurrenceTypeField}</Col>
				<Col sm={6}>
					{Number(recurrenceType) === 0 /* none */ && this.renderDateField()}
					{Number(recurrenceType) === 2 /* weekly */ && this.renderDaysOfWeekField()}
					</Col></div>}
				{!isNew && <Col sm={12}>{this.renderDateField()}</Col>}
			</Row>
		];

		if (isNew && Number(recurrenceType) === 2) {	// weekly
			fields.push(<Row>
				<Col sm={6}>{this.renderDateInput('startDate', t('WeeklyProgram_StartDate'), isReadonly)}</Col>
				<Col sm={6}>{this.renderDateInput('endDate', t('WeeklyProgram_EndDate'), isReadonly)}</Col>
			</Row>);
		}

		fields.push(<Row>
			<Col sm={12}>{grade}</Col>
		</Row>);

		fields.push(<Row>
			<Col sm={6}>{from}</Col>
			<Col sm={6}>{to}</Col>
		</Row>);

		fields.push(<Row>
			<Col sm={6}>{this.renderPriceField()}</Col>
		</Row>)

		fields.push(<Row>
			<Col sm={12/priceNumber}>{maxChildren}</Col>
			{enableTrials && <Col sm={12/priceNumber}>{maxTrialChildren}</Col>}
			{enableMakeUps && <Col sm={12/priceNumber}>{maxMakeUpChildren}</Col>}
		</Row>);

		return fields;
	}

	render() {
		const { error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, onDelete, t,
			initialValues, type, teachers, enableMakeUps, enableTrials, timetableViewType, frontOfficeUrl, useTermDefault, useGradeDefault } = this.props;
		const editMode = initialValues && initialValues.id;
		const publicPageUrl = editMode && `${frontOfficeUrl}/public/timetable/${initialValues.centerId}/${initialValues.id}`;
		const rows = this.renderRows();
		return (
			<Grid>
				<Form onSubmit={handleSubmit}>
					{error && <Alert bsStyle='danger'>{error}</Alert>}
					{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}
					{rows}
					{(enableMakeUps || enableTrials) && <Row>
						<Col sm={12}><Field name='blockBookingIfFull' component={Checkbox} disabled={isReadonly} label={t('WeeklyProgram_BlockBookingIfFull')} normalize={(v) => { return !!v }} /></Col>
					</Row>}
					<label className='control-label'>{t('WeeklyProgram_Name')}</label>
					<Field name='useGradeDefault' component={Checkbox} disabled={isReadonly} label={t('WeeklyProgram_UseGradeDefault')} normalize={(v) => !!v}/>
					{!useGradeDefault && <Field name='name' component={Input} disabled={isReadonly} type='text' />}
					<Field name='description' component={Input} disabled={isReadonly} type='text' label={t('WeeklyProgram_Description')} />
					<label className='control-label'>{t('Term_ThemeDescription')}</label>
					<Field name='useTermDefault' component={Checkbox} disabled={isReadonly}	label={t('WeeklyProgram_UseTermDefault')} normalize={(v) => !!v}/>
					{!useTermDefault && <Field name='themeDescription' component={HtmlEditor} disabled={isReadonly} height={150} />}
					<Row>
						<Col sm={6}>
							<Field name='roomNumber' component={Input} disabled={isReadonly} label={t('WeeklyProgram_RoomNumber')} />
						</Col>
						<Col sm={6}>
							<Select name='teacherId' disabled={isReadonly} label={t('WeeklyProgram_Teacher')} data={teachers} />
						</Col>
					</Row>
					<Row>
						<Col sm={6}><Field name='lockForPreviousTermCustomersOnly' component={Checkbox} disabled={isReadonly} label={t('WeeklyProgram_LockForPreviousTermCustomersOnly')} normalize={(v) => { return !!v }} /></Col>
						<Col sm={6}><Field name='isClosed' component={Checkbox} disabled={isReadonly} label={t('WeeklyProgram_IsClosed')} normalize={(v) => { return !!v }} /></Col>
					</Row>
					<Row>
						<Col sm={6}><Field name='isRemote' component={Checkbox} disabled={isReadonly} label={t('WeeklyProgram_IsRemote')} normalize={(v) => { return !!v }} /></Col>
						<Col sm={6}><Field name='sendClassReminder' component={Checkbox} disabled={isReadonly} label={t('WeeklyProgram_SendClassReminder')} normalize={(v) => { return !!v }} /></Col>
					</Row>
					{(timetableViewType === 'List' || timetableViewType === 2) && <Row>
						<Col sm={6}><Field name='hidden' component={Checkbox} disabled={isReadonly} label={t('WeeklyProgram_Hidden')} help={t('WeeklyProgram_Hidden_Hint')} normalize={(v) => { return !!v }} /></Col>
						{editMode && <Col sm={6}>
							<a href={publicPageUrl} target='_blank'>{t('WeeklyProgramItem_PublicPage')}</a>
							<a onClick={() => utils.copyToClipboard(publicPageUrl)} title='Copy' style={{ marginLeft: '10px', cursor: 'pointer' }}><FontAwesomeIcon icon={faCopy} /></a>
						</Col>}
					</Row>}
					<Row className='invisible'>
						{(type == types.TRIAL || type == types.SINGLE) && < Field name='weekday' component={Input} type='hidden' />}
						<Field name='centerId' component={Input} type='hidden' />
						<Field name='termId' component={Input} type='hidden' />
						<Field name='status' component={Input} type='hidden' />
						<Field name='isDeleted' component={Input} type='hidden' />
					</Row>
				</Form>
			</Grid>
		);
	};

}

export default reduxForm({ form: 'weeklyProgram' })(SettingsForm);

export const selector = formValueSelector('weeklyProgram');
